module.exports = __webpack_public_path__ + "img/empty.c7219e46.png";